import { jsx } from "react/jsx-runtime";
import { RemoveScroll as RS } from "react-remove-scroll";
const RemoveScroll = (props) => {
  if (!props.children)
    return null;
  return /* @__PURE__ */ jsx(RS, { ...props });
};
RemoveScroll.classNames = RS.classNames;
export {
  RemoveScroll
};
//# sourceMappingURL=RemoveScroll.js.map
